import { handleGlobalGetRequestQuery } from "@/lib/httpFunction/globalApiFunction";
import { QUERY_KEYS } from "@/services/KEYS/QUERY_KEYS";
import { CORE_URLS } from "@/services/URLS/CORE_URLS";
import { useQuery } from "@tanstack/react-query";
import { LucideIcon } from "lucide-react";

export interface AdminStep {
  icon: LucideIcon;
  id: number;
  name: string;
  route: string;
  slug: string;
  submenus: any[];
}

export interface AdminMenuResponse {
  menus: AdminStep[];
  status?: string;
}

export const useGetAdminMenu = () => {
  const getAllAdminMenu = useQuery<AdminMenuResponse>({
    queryKey: [QUERY_KEYS.ADMIN_MENU],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: CORE_URLS.ADMIN_MENU,
      }),
  });

  return {
    services: { getAllAdminMenu },
  };
};
